export default __webpack_public_path__ + "static/media/turn-right.5ce64e33.svg";